import React from "react";

import { Typography } from "@mui/material";
import { round } from "lodash";
import { makeStyles } from "tss-react/mui";

interface Props {
  caloriesConsumed?: number;
  recommendedCalories?: number;
}

const TotalCaloriesConsumed: React.FC<Props> = ({
  caloriesConsumed,
  recommendedCalories,
}) => {
  const { classes, cx } = useStyles();

  const progress = (caloriesConsumed ?? 0) / (recommendedCalories || 1);

  return (
    <section className={classes.root}>
      <Typography className={classes.title}>Total Calories Consumed</Typography>
      <meter className={classes.progress} value={progress}></meter>
      <div className={classes.footer}>
        <div>
          <Typography className={classes.text}>Consumed</Typography>
          <Typography className={classes.caloriesConsumed}>
            {round(caloriesConsumed ?? 0)}
          </Typography>
        </div>
        <div>
          <Typography className={cx(classes.text, classes.right)}>
            Goal
          </Typography>
          <Typography
            className={cx(classes.recommendedCalories, classes.right)}
          >
            {round(recommendedCalories ?? 0)}
          </Typography>
        </div>
      </div>
    </section>
  );
};

const useStyles = makeStyles()({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 20px 15px",
    backgroundColor: "#fff",
  },
  title: {
    color: "#363E45",
    fontSize: 16,
    fontWeight: 700,
  },
  progress: {
    marginTop: 14,
    marginBottom: 5,
    height: 7,
    width: "100%",
    "&::-webkit-meter-bar": {
      borderRadius: 9999,
      height: 7,
      border: "none",
      backgroundColor: "#EDF0F5",
    },
    "&::-webkit-meter-optimum-value": {
      borderRadius: 9999,
      background:
        "linear-gradient(90deg, rgba(255,186,27,1) 0%, rgba(255,151,44,1) 100%)",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
  },
  text: {
    color: "#4C515A",
    fontSize: 12,
    fontWeight: 600,
  },
  caloriesConsumed: {
    color: "#4C515A",
    fontSize: 16,
    fontWeight: 700,
  },
  recommendedCalories: {
    color: "#4C515A",
    fontSize: 16,
    fontWeight: 700,
  },
  right: {
    textAlign: "right",
  },
});

export default TotalCaloriesConsumed;
